import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Center,
  VStack,
  HStack,
  Text,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  useDisclosure,
  Icon,
  Avatar,
  AvatarBadge,
  useToast,
} from "@chakra-ui/react";
import MessageAreaScreen from "./MessageAreaScreen";
import { BsCircleFill } from "react-icons/bs";
import { BsListNested } from "react-icons/bs";

import { socket } from "../service/socket";
import App from "../App";

export default function FirstScreen({ username }) {
  const [rooms, setrooms] = useState(["gaming", "developement", "Any Thing"]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const [connectedusers, setconnectedusers] = useState([]);
  const [gamers, setgamers] = useState([]);
  const [developers, setdevelopers] = useState([]);
  const [others, setothers] = useState([]);
  const [room, setroom] = useState("general");
  const [messages, setmessages] = useState([]);
  const audio = useRef();

  const toast = useToast();

  const resetMessages = () => {
    setmessages([]);
  };

  const Func = () => {
    setroom("general");
    resetMessages();
    socket.emit("join general room");
    socket.emit("set general", username);
  };

  useEffect(() => {
    // socket.emit("join general room");
    Func();
  }, []);

  useEffect(() => {
    socket.on("disconnectedUser", (user) => {
      toast({
        title: `${user} has left chato`,
        position: "top-right",
        isClosable: true,
      });
    });

    socket.on("new user", (user) => {
      console.log("rani hna", user);
      toast({
        title: `${user} joined chato`,
        position: "top-right",
        isClosable: true,
      });
    });

    //get users from server
    socket.on("loged user", (user) => {
      console.log(user);
      console.log("jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj");
      const newArray = [];
      for (const key in user) {
        // console.log(pp[key])
        newArray.push(user[key]);
      }
      setconnectedusers([...newArray]);
      // setconnectedusers([...user]);
    });

    //============== online gamers list ===================

    socket.on("gamers", (user) => {
      console.log(user);
      const newArray = [];
      for (const key in user) {
        // console.log(pp[key])
        newArray.push(user[key]);
      }
      setgamers([...newArray]);
      // setconnectedusers([...user]);
    });

    //===================================================

    //============== online developers list ===================

    socket.on("developers", (user) => {
      console.log(user);
      const newArray = [];
      for (const key in user) {
        // console.log(pp[key])
        newArray.push(user[key]);
      }
      setdevelopers([...newArray]);
      // setconnectedusers([...user]);
    });

    //===================================================
    //============== online others list ===================

    socket.on("others", (user) => {
      console.log(user);
      const newArray = [];
      for (const key in user) {
        // console.log(pp[key])
        newArray.push(user[key]);
      }
      setothers([...newArray]);
      // setconnectedusers([...user]);
    });

    //===================================================
  }, []);

  useEffect(() => {
    socket.on("room1", (res) => {
      console.log("you joined room : ", res);
      setmessages((prev) => [...prev, res]);
    });
  }, []);

  return (
    <Box>
      <Box h="15vh" display="flex" alignItems="center">
        <Button
          fontSize={30}
          ref={btnRef}
          //  rounded={5}
          color="black"
          colorScheme="transparent"
          onClick={onOpen}
          m={4}
        >
          <Icon as={BsListNested} />
        </Button>{" "}
      </Box>
      <HStack
        spacing={0}
        w="100%"
        h="90%"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Drawer
          isOpen={isOpen}
          placement="right"
          onClose={onClose}
          finalFocusRef={btnRef}
        >
          <DrawerOverlay bg="none" border="none">
            <DrawerContent
              bg="transparent"
              border="none"
              roundedBottomStart={100}
              roundedTopStart={100}
            >
              <Box
                //  display={{ base: "none", md: "block" }}
                w="100%"
                h="100%"
                bg="#3E9FA5"
                overflow="auto"
                //roundedBottomStart={100}
                // roundedTopEnd={100}
                // roundedTopStart={50}
                //  roundedBottomEnd={100}
              >
                <Center h="20%">
                  <Text color="white" fontSize="2xl" fontFamily="monospace">
                    {" "}
                    Welcome {username}
                  </Text>
                </Center>
                <VStack d="flex" spacing={5} alignItems="center">
                  <Box w="90%">
                    {" "}
                    <Text color="white">#rooms</Text>
                  </Box>
                  <Box
                    // textAlign="center"
                    w="90%"
                    bg="#1A8E96"
                    color="white"
                    p={3}
                    rounded={10}
                    onClick={() => {
                      Func();
                      var audio = new Audio(
                        "https://www.myinstants.com/media/sounds/discord-sounds.mp3"
                      );
                      audio.play();
                    }}
                  >
                    general
                  </Box>
                  {connectedusers.map((item, index) => {
                    return (
                      <HStack
                        spacing={3}
                        color="white"
                        //   bg="#1A8E96"
                        w="90%"
                        rounded={5}
                        pl={10}
                        key={index}
                      >
                        {" "}
                        <Avatar size="sm">
                          <AvatarBadge boxSize="1.25em" bg="green.500" />
                        </Avatar>{" "}
                        <Text>{item.name}</Text>
                      </HStack>
                    );
                  })}
                  <Box
                    // textAlign="center"
                    w="90%"
                    bg="#1A8E96"
                    color="white"
                    p={3}
                    rounded={10}
                    onClick={() => {
                      setroom("room1");
                      resetMessages();
                      socket.emit("join room 1");
                      socket.emit("set gamers", username);
                      var audio = new Audio(
                        "https://www.myinstants.com/media/sounds/discord-sounds.mp3"
                      );
                      audio.play();
                    }}
                  >
                    gaming
                  </Box>
                  {gamers.map((item, index) => {
                    return (
                      <HStack
                        spacing={3}
                        color="white"
                        //   bg="#1A8E96"
                        w="90%"
                        rounded={5}
                        pl={10}
                        key={index}
                      >
                        {" "}
                        <Avatar size="sm">
                          <AvatarBadge boxSize="1.25em" bg="green.500" />
                        </Avatar>{" "}
                        <Text>{item.name}</Text>
                      </HStack>
                    );
                  })}
                  <Box
                    // textAlign="center"
                    w="90%"
                    bg="#1A8E96"
                    color="white"
                    p={3}
                    rounded={10}
                    onClick={() => {
                      setroom("room2");
                      resetMessages();
                      socket.emit("join room 2");
                      socket.emit("set developers", username);
                      var audio = new Audio(
                        "https://www.myinstants.com/media/sounds/discord-sounds.mp3"
                      );
                      audio.play();
                    }}
                  >
                    developement
                  </Box>
                  {developers.map((item, index) => {
                    return (
                      <HStack
                        spacing={3}
                        color="white"
                        //   bg="#1A8E96"
                        w="90%"
                        rounded={5}
                        pl={10}
                        key={index}
                      >
                        {" "}
                        <Avatar size="sm">
                          <AvatarBadge boxSize="1.25em" bg="green.500" />
                        </Avatar>{" "}
                        <Text>{item.name}</Text>
                      </HStack>
                    );
                  })}
                  <Box
                    //   textAlign="center"
                    color="white"
                    w="90%"
                    bg="#1A8E96"
                    p={3}
                    rounded={10}
                    onClick={() => {
                      setroom("room3");
                      resetMessages();
                      socket.emit("join room 3");
                      socket.emit("set others", username);
                      var audio = new Audio(
                        "https://www.myinstants.com/media/sounds/discord-sounds.mp3"
                      );
                      audio.play();
                    }}
                  >
                    others
                  </Box>
                  {others.map((item, index) => {
                    return (
                      <HStack
                        spacing={3}
                        color="white"
                        //   bg="#1A8E96"
                        w="90%"
                        rounded={5}
                        pl={10}
                        key={index}
                      >
                        {" "}
                        <Avatar size="sm">
                          <AvatarBadge boxSize="1.25em" bg="green.500" />
                        </Avatar>{" "}
                        <Text>{item.name}</Text>
                      </HStack>
                    );
                  })}
                </VStack>
              </Box>
            </DrawerContent>
          </DrawerOverlay>
        </Drawer>

        <Box w={{ base: "100%", md: "100%" }} h="100%">
          <App usr={username} room={room} />
        </Box>
      </HStack>
    </Box>
  );
}
